<template>
  <div class="notifications-shell d-flex align-items-center">
    <div v-if="!$isMobile" class="classic-notifications">
      <div
        class="notif-trigger dropdown d-flex"
        :class="{ inactive: validateSubMneu() }"
      >
        <i
          v-if="hasUnreadClassic"
          class="fas fa-circle notification-dot"
        ></i>

        <button
          type="button"
          class="dropdown-toggle notification-btn"
          data-toggle="dropdown"
          aria-expanded="false"
          @click="markClassicDropdownOpened"
        >
          <span class="feather-icon select-none relative">
            <svg
              width="21px"
              height="21px"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.6"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0"
              />
            </svg>
          </span>
        </button>

        <div class="dropdown-menu notifications-dropdown">
          <div class="popover-arrow-wrap">
            <div class="popover-arrow">
              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="9" role="presentation">
                <g fill="none" fill-rule="evenodd">
                  <path
                    fill="#fff"
                    fill-opacity="0.1"
                    d="M1 9.092h19l-6.402-6.74c-1.717-1.806-4.485-1.8-6.196 0L1 9.093zM20.342 8l-6.02-6.336c-2.108-2.22-5.538-2.218-7.645 0L.658 8h19.684z"
                  />
                  <path
                    fill="#fff"
                    d="M7.402 2.353c1.711-1.801 4.48-1.807 6.196 0L20 9.093H1l6.402-6.74z"
                  />
                </g>
              </svg>
            </div>
          </div>

          <div class="notifications-head">
            <div class="head-left">
              <h4>{{ $t('templateComps.notificationsNav.title') }}</h4>
              <small v-if="classicNotifications.length">{{ classicNotifications.length }} {{ $t('templateComps.notificationsNav.recent') }}</small>
            </div>
          </div>

          <div v-if="classicNotifications.length" class="notifications-scroll">
            <div class="cn-list">
              <div
                v-for="item in classicNotifications"
                :key="item.id"
                class="cn-card"
                :class="'tone-' + nMeta(item.type).cls"
                @click="openBookingNotification(item)"
              >
                <div class="cn-left">
                  <span class="cn-hour">{{ clockTime(item.created_at) }}</span>
                  <span class="cn-cat">{{ nMeta(item.type).category }}</span>
                </div>

                <div class="cn-divider"></div>

                <div class="cn-main">
                  <h5 class="cn-title">{{ item.title }}</h5>
                  <p class="cn-line">
                    <span class="cn-status">{{ nMeta(item.type).status }}</span>
                    <span class="cn-sep">·</span>
                    <span class="cn-text">{{ item.body }}</span>
                  </p>
                </div>

                <i class="fas fa-chevron-right cn-chev"></i>
              </div>
            </div>
          </div>

          <div v-else class="notifications-empty">
            <div class="empty-icon">
              <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" stroke-width="1.6">
                <path d="M12 6v6l3 2" />
                <circle cx="12" cy="12" r="9" />
              </svg>
            </div>
            <h5>{{ $t('templateComps.notificationsNav.emptyTitle') }}</h5>
            <p>{{ $t('templateComps.notificationsNav.emptyText') }}</p>
          </div>

          <div class="notifications-foot">
            <button type="button" class="ntf-seeall" @click="goAllNotifications">
              <span>{{ $t('templateComps.notificationsNav.seeAll') }}</span>
              <i class="fas fa-arrow-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="contenedorNotificaciones d-flex">
      <i
        v-if="hasBotNotifications"
        class="fas fa-circle notification-dot"
        aria-hidden="true"
      ></i>
      <button
        @click="openBotModal"
        type="button"
        class="cursor-pointer vs-con-dropdown bot-notification-btn"
      >
        <!-- Sin `sm:mr-6`: esa utilidad global mete `margin-right: 1.5rem !important`
             (main.css) DENTRO del boton, y ese era el hueco que separaba el robot del
             resto. Al ir con !important desde una hoja global, ninguna regla scoped
             de aqui ni del padre podia con ella. -->
        <span class="cursor-pointer feather-icon select-none relative">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            style="width: 22px; height: 22px"
          >
            <path fill="currentColor" d="M20.006 15.344a.544.544 0 0 0-1.012 0l-.946 2.398a.54.54 0 0 1-.306.306l-2.398.946a.544.544 0 0 0 0 1.012l2.398.946c.14.055.251.166.306.306l.946 2.398c.181.459.83.459 1.012 0l.946-2.398a.54.54 0 0 1 .306-.306l2.398-.946a.544.544 0 0 0 0-1.012l-2.398-.946a.54.54 0 0 1-.306-.306z" />
            <path fill="currentColor" d="M12 .125a1 1 0 0 1 1 1v2.48c0 .112 0 .169.029.208q.014.02.033.033c.04.029.096.029.208.029h.005c1.665 0 2.994-.001 4.052.113 1.077.117 1.99.364 2.78.938a5.5 5.5 0 0 1 1.217 1.217c.574.79.821 1.703.938 2.78.114 1.058.113 2.387.113 4.052v.3q0 .661-.002 1.253c-.003.441-.004.662-.087.703a.15.15 0 0 1-.08.015c-.092-.009-.175-.218-.34-.636l-.085-.195a2.47 2.47 0 0 0-1.243-1.2c-.066-.03-.1-.044-.12-.064a.14.14 0 0 1-.032-.05c-.011-.026-.011-.06-.011-.126 0-1.71-.001-2.911-.102-3.836-.098-.907-.28-1.429-.566-1.822a3.5 3.5 0 0 0-.774-.774c-.393-.285-.915-.468-1.822-.566-.925-.1-2.126-.102-3.836-.102h-2.55c-1.71 0-2.911.001-3.836.102-.907.098-1.43.28-1.822.566a3.5 3.5 0 0 0-.774.774c-.285.393-.468.915-.566 1.822-.1.925-.102 2.126-.102 3.836v.3c0 1.71.001 2.911.102 3.836.098.907.28 1.43.566 1.822a3.5 3.5 0 0 0 .774.774c.393.285.915.468 1.822.566.925.1 2.126.102 3.836.102h2.236c.08 0 .12 0 .152.016q.015.006.029.019c.027.022.045.062.08.142.25.564.713 1.048 1.388 1.314.418.165.627.248.636.34a.15.15 0 0 1-.015.08c-.041.083-.262.084-.703.087q-.592.003-1.253.002h-2.55c-1.665 0-2.994.001-4.052-.113-1.077-.117-1.99-.364-2.78-.938a5.5 5.5 0 0 1-1.217-1.217c-.574-.79-.821-1.703-.938-2.78-.114-1.058-.113-2.387-.113-4.052v-.3c0-1.665-.001-2.994.113-4.052.117-1.077.364-1.99.938-2.78a5.5 5.5 0 0 1 1.217-1.217c.79-.574 1.703-.821 2.78-.938 1.058-.114 2.387-.113 4.052-.113h.005c.112 0 .169 0 .208-.029a.2.2 0 0 0 .033-.033c.029-.04.029-.096.029-.208v-2.48a1 1 0 0 1 1-1" />
            <path fill="currentColor" d="M8.25 11.25a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M15.75 11.25a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3" />
          </svg>
        </span>
      </button>
    </div>

    <NotificationsModal
      :markAllAsRead="markAllAsRead"
      :toggleBotModal="toggleBotModal"
      :botNotifications="botNotifications"
      :hasBotNotifications="hasBotNotifications"
      :selectNotification="selectNotification"
      :archiveNotification="archiveNotification"
      :property="property"
      @open-conversation="openConversation"
      :loading="storeLoading"
    />

  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import $ from "jquery";
import NotificationsModal from "@/components/chatBot/NotificationsModal.vue";
import axios from "axios";

export default {
  name: "NotificationsContainer",
  components: {
    NotificationsModal,
  },
  data() {
    return {
      showBotModal: false,
      botLoading: false,
    };
  },
  computed: {
    ...mapState(["notificaciones"]),
    ...mapState("chatbot", ["list"]),
    ...mapGetters("chatbot", {
      globalChats: "globalChats",
      storeLoading: "loading",
      hasUnreadGlobal: "hasUnreadGlobal",
    }),

    user() {
      return this.$store.state.userRoot || {};
    },

    property() {
      return this.$store.state.property?.property || {};
    },

    classicNotifications() {
      return Array.isArray(this.notificaciones) ? this.notificaciones : [];
    },

    hasUnreadClassic() {
      return !!this.$store.state.state_notificacion && this.classicNotifications.length > 0;
    },

    botNotifications() {
      if (!this.globalChats?.length) return [];

      return this.globalChats.map((r, idx) => {
        const ts = r.last_inbound_at || r.last_message_at || null;
        const rawPhone = String(r.phone_number || "");
        const phoneDisplay = this.ensurePlus(rawPhone);
        const phoneDigits = this.onlyDigits(rawPhone);

        const senderName =
          r.guest_name && r.guest_name.trim()
            ? r.guest_name.trim()
            : phoneDisplay || "—";

        return {
          id: r.chat_id,
          chat_id: r.chat_id,
          chat_ids: r.chat_ids || [],
          key: `${rawPhone || idx}|${r.checkin_id ?? "none"}`,
          checkinId: r.checkin_id ?? null,
          senderName,
          senderPhone: phoneDisplay,
          phoneDigits,
          message: r.last_message_preview || "",
          timestamp: ts ? new Date(ts) : new Date(),
          read: !r.has_new_message,
          unread: !!r.has_new_message,
          unread_count:
            typeof r.unread_count === "number" ? r.unread_count : 0,
          has_new_message: !!r.has_new_message,
          raw: r,
        };
      });
    },

    hasBotNotifications() {
      return this.hasUnreadGlobal;
    },
  },

  mounted() {
    $(".dropdown-menu").on("click", function (e) {
      e.stopPropagation();
    });

    if (this.property) {
      this.retrieveBotChats();
    }
  },

  watch: {
    property() {
      this.onAccessChange();
    },
    user() {
      this.onAccessChange();
    },

    // La bandeja se renderiza DENTRO del <nav>, que es `position: fixed; z-index: 999`
    // y por tanto crea su propio contexto de apilamiento. El banner de suscripción está
    // a z-index 1000, así que TODO el navbar (y el drawer dentro de él) quedaba pintado
    // por debajo del banner, por muy alto que fuese el z-index del drawer. Mientras la
    // bandeja está abierta elevamos el navbar; no tapa nada porque el banner ocupa la
    // franja superior y el navbar empieza justo debajo.
    showBotModal(open) {
      document.body.classList.toggle("bot-drawer-open", !!open);
    },
  },

  beforeDestroy() {
    document.body.classList.remove("bot-drawer-open");
  },

  methods: {
    markClassicDropdownOpened() {
      this.$store.state.state_notificacion = false;
    },

    goAllNotifications() {
      // Cierra el dropdown de Bootstrap antes de navegar.
      try {
        $(this.$el).find(".notification-btn.dropdown-toggle").dropdown("hide");
      } catch (e) {
        /* noop */
      }
      this.$store.state.state_notificacion = false;
      if (this.$route.name !== "notificacionesUser") {
        this.$router.push({ name: "notificacionesUser" }).catch(() => {});
      }
    },

    // Metadatos por tipo (mismo criterio que la página completa de notificaciones).
    nMeta(type) {
      const map = {
        1: { status: this.$t("templateComps.notificationsNav.meta.t1.status"), category: this.$t("templateComps.notificationsNav.meta.t1.category"), cls: "green" },
        2: { status: this.$t("templateComps.notificationsNav.meta.t2.status"), category: this.$t("templateComps.notificationsNav.meta.t2.category"), cls: "blue" },
        3: { status: this.$t("templateComps.notificationsNav.meta.t3.status"), category: this.$t("templateComps.notificationsNav.meta.t3.category"), cls: "red" },
        4: { status: this.$t("templateComps.notificationsNav.meta.t4.status"), category: this.$t("templateComps.notificationsNav.meta.t4.category"), cls: "teal" },
        5: { status: this.$t("templateComps.notificationsNav.meta.t5.status"), category: this.$t("templateComps.notificationsNav.meta.t5.category"), cls: "orange" },
        6: { status: this.$t("templateComps.notificationsNav.meta.t6.status"), category: this.$t("templateComps.notificationsNav.meta.t6.category"), cls: "purple" },
        7: { status: this.$t("templateComps.notificationsNav.meta.t7.status"), category: this.$t("templateComps.notificationsNav.meta.t7.category"), cls: "emerald" },
        8: { status: this.$t("templateComps.notificationsNav.meta.t8.status"), category: this.$t("templateComps.notificationsNav.meta.t8.category"), cls: "rose" },
        9: { status: this.$t("templateComps.notificationsNav.meta.t9.status"), category: this.$t("templateComps.notificationsNav.meta.t9.category"), cls: "indigo" },
        10: { status: this.$t("templateComps.notificationsNav.meta.t10.status"), category: this.$t("templateComps.notificationsNav.meta.t10.category"), cls: "amber" },
        11: { status: this.$t("templateComps.notificationsNav.meta.t11.status"), category: this.$t("templateComps.notificationsNav.meta.t11.category"), cls: "purple" },
        12: { status: this.$t("templateComps.notificationsNav.meta.t12.status"), category: this.$t("templateComps.notificationsNav.meta.t12.category"), cls: "rose" },
        13: { status: this.$t("templateComps.notificationsNav.meta.t13.status"), category: this.$t("templateComps.notificationsNav.meta.t13.category"), cls: "rose" },
        15: { status: this.$t("templateComps.notificationsNav.meta.t15.status"), category: this.$t("templateComps.notificationsNav.meta.t15.category"), cls: "emerald" },
      };
      return map[Number(type)] || { status: this.$t("templateComps.notificationsNav.meta.default.status"), category: this.$t("templateComps.notificationsNav.meta.default.category"), cls: "slate" };
    },

    clockTime(date) {
      if (!date) return "";
      const d = new Date(date);
      if (isNaN(d.getTime())) return "";
      return d.toLocaleTimeString("es-ES", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });
    },

    isUnread(item) {
      return this.$store.state.state_notificacion === true;
    },

    notificationTypeClass(item) {
      const type = Number(item.type);

      switch (type) {
        case 1:
          return {
            label: this.$t("templateComps.notificationsNav.typeLabel.t1"),
            chipClass: "chip-green",
            iconClass: "icon-green",
          };
        case 2:
          return {
            label: this.$t("templateComps.notificationsNav.typeLabel.t2"),
            chipClass: "chip-blue",
            iconClass: "icon-blue",
          };
        case 3:
          return {
            label: this.$t("templateComps.notificationsNav.typeLabel.t3"),
            chipClass: "chip-red",
            iconClass: "icon-red",
          };
        case 4:
          return {
            label: this.$t("templateComps.notificationsNav.typeLabel.t4"),
            chipClass: "chip-slate",
            iconClass: "icon-slate",
          };
        case 5:
          return {
            label: this.$t("templateComps.notificationsNav.typeLabel.t5"),
            chipClass: "chip-orange",
            iconClass: "icon-orange",
          };
        case 6:
          return {
            label: this.$t("templateComps.notificationsNav.typeLabel.t6"),
            chipClass: "chip-purple",
            iconClass: "icon-purple",
          };
        case 7:
          return {
            label: this.$t("templateComps.notificationsNav.typeLabel.t7"),
            chipClass: "chip-emerald",
            iconClass: "icon-emerald",
          };
        case 8:
          return {
            label: this.$t("templateComps.notificationsNav.typeLabel.t8"),
            chipClass: "chip-rose",
            iconClass: "icon-rose",
          };
        case 10:
          return {
            label: this.$t("templateComps.notificationsNav.typeLabel.t10"),
            chipClass: "chip-amber",
            iconClass: "icon-amber",
          };
        case 11:
          return {
            label: this.$t("templateComps.notificationsNav.typeLabel.t11"),
            chipClass: "chip-purple",
            iconClass: "icon-purple",
          };
        case 12:
          return {
            label: this.$t("templateComps.notificationsNav.typeLabel.t12"),
            chipClass: "chip-rose",
            iconClass: "icon-rose",
          };
        case 13:
          return {
            label: this.$t("templateComps.notificationsNav.typeLabel.t13"),
            chipClass: "chip-rose",
            iconClass: "icon-rose",
          };
        case 15:
          return {
            label: this.$t("templateComps.notificationsNav.typeLabel.t15"),
            chipClass: "chip-emerald",
            iconClass: "icon-emerald",
          };
        default:
          return {
            label: this.$t("templateComps.notificationsNav.typeLabel.default"),
            chipClass: "chip-slate",
            iconClass: "icon-slate",
          };
      }
    },

    formatRelativeTime(date) {
      if (!date) return "";

      const now = new Date();
      const target = new Date(date);
      const diffMs = now.getTime() - target.getTime();
      const diffSec = Math.floor(diffMs / 1000);
      const diffMin = Math.floor(diffSec / 60);
      const diffHour = Math.floor(diffMin / 60);
      const diffDay = Math.floor(diffHour / 24);

      if (diffSec < 45) return "hace unos segundos";
      if (diffMin < 60) return `hace ${diffMin} minuto${diffMin === 1 ? "" : "s"}`;
      if (diffHour < 24) return `hace ${diffHour} hora${diffHour === 1 ? "" : "s"}`;
      if (diffDay < 7) return `hace ${diffDay} día${diffDay === 1 ? "" : "s"}`;

      return target.toLocaleDateString();
    },

    openBookingNotification(notification) {
      const type = Number(notification?.type);
      // Limpieza (housekeeping, tipos 20/21/22): al tablero de limpieza.
      if (type === 20 || type === 21 || type === 22) {
        this.hideClassicDropdown();
        if (this.$route.name !== "Housekeeping") {
          this.$router.push({ name: "Housekeeping" }).catch(() => {});
        }
        return;
      }
      // Suscripción activa (tipo 15; relation_id es el pedido, no una reserva).
      if (type === 15) {
        this.hideClassicDropdown();
        if (this.$route.name !== "subscriptionSettings") {
          this.$router.push({ name: "subscriptionSettings" }).catch(() => {});
        }
        return;
      }
      if (!notification?.relation_id) return;
      this.hideClassicDropdown();
      // Abrir el drawer lateral (no navegar a la vista completa DetalleReserva).
      // La notificación guarda relation_id (booking_id); el user_id se resuelve con
      // el usuario en sesión (dueño del panel), que es lo que espera la reserva.
      this.$root.$emit("open-reservation-drawer", {
        userId: this.user?.id,
        reservaId: notification.relation_id,
      });
    },

    // Cierra el dropdown de Bootstrap antes de navegar.
    hideClassicDropdown() {
      try {
        $(this.$el).find(".notification-btn.dropdown-toggle").dropdown("hide");
      } catch (e) {
        /* noop */
      }
    },

    async archiveNotification(notification) {
      const raw = notification.raw || {};
      const propertyId =
        raw.property_id ||
        this.property?.id ||
        this.property?.property_id ||
        null;

      const reservationId = raw.reservation_id || raw.reserva_id || null;
      const phone =
        notification.senderPhone ||
        raw.phone_number ||
        raw.reservation_phone ||
        "";

      if (!propertyId || !phone) {
        console.warn("Faltan datos para archivar conversación", { propertyId, phone });
        return;
      }

      try {
        await axios.post("/bot/conversations/archive", {
          phone_number: phone,
          property_id: propertyId,
          reservation_id: reservationId,
        });

        await this.retrieveBotChats();
      } catch (e) {
        console.error("Error archivando conversación", e);
      }
    },

    isTruthy(v) {
      return v === true || v === 1 || v === "1" || v === "true";
    },

    ensurePlus(phone) {
      if (!phone) return "";
      const s = String(phone).trim();
      return s.startsWith("+") ? s : `+${s}`;
    },

    onlyDigits(phone) {
      return String(phone || "").replace(/\D/g, "");
    },

    onAccessChange() {
      if (this.property) {
        this.retrieveBotChats();
      } else {
        this.showBotModal = false;
        this.isVisibleConversation = false;
      }
    },

    async retrieveBotChats() {
      if (!this.property?.id) return;

      this.botLoading = true;

      await this.$store.dispatch("chatbot/retrieveGlobalChats", {
        user_id: this.$store.state.userRoot.id,
        property_id: "all",
        limit: 50,
      });

      this.botLoading = false;
    },

    closeDropdown(event) {
      const dropdownMenu = $(event.target).closest(".dropdown");
      dropdownMenu.find(".dropdown-toggle").dropdown("hide");
    },

    activeEvent(reason, id) {
      if (reason == "checkin") this.$emit("eventActiveModalData", id);
      else if (reason == "service") this.$emit("eventOpenService", id);
    },

    validateSubMneu() {
      return this.$route.name == "pageSubscription";
    },

    openBotModal() {
      this.showBotModal = true;
    },

    toggleBotModal(value) {
      this.showBotModal = value;
    },

    async markItemAsRead(notification) {
      const chatId =
        notification.chat_id ||
        notification.id ||
        notification.raw?.chat_id ||
        (Array.isArray(notification.chat_ids) ? notification.chat_ids[0] : null);

      if (!chatId) {
        console.warn("No hay chatId para marcar como leído", notification);
        return;
      }

      try {
        await axios.post("/mark-as-read", {
          chat_id: chatId,
        });

        this.$store.commit("chatbot/MARK_ONE_READ", {
          chat_id: chatId,
        });
      } catch (e) {
        console.error("Error markItemAsRead:", e);
      }
    },

    async markAllAsRead() {
      try {
        await axios.put("/mark-all-as-read", {
          property_id: "all",
          user_id: this.$store.state.userRoot.id,
        });

        this.$store.commit("chatbot/MARK_ALL_READ");
      } catch (e) {
        console.error("Error markAllAsRead:", e);
      }
    },

    async selectNotification(notification) {
      if (!notification.read) {
        await this.markItemAsRead(notification);
        this.$emit("markNotificationAsRead", notification.id);
      }
      this.openConversation(notification);
    },


    // Abrir una conversación de la bandeja = abrir el DRAWER DE LA RESERVA y aterrizar
    // en la pestaña del canal por el que escribió el huésped (WhatsApp / Conserje web /
    // OTA). Así el operador ve siempre el contexto completo de la reserva y responde en
    // el mismo sitio, sea cual sea el canal — en vez de un modal aparte por canal.
    openConversation(item) {
      const chatId =
        item?.chat_id ||
        item?.id ||
        item?.raw?.chat_id ||
        item?.raw?.id ||
        (Array.isArray(item?.chat_ids) ? item.chat_ids[0] : null);

      const reservaId =
        item?.reservation_id ||
        item?.raw?.reservation_id ||
        item?.raw?.reserva_id ||
        null;

      const channel = String(
        item?.channel || item?.raw?.channel || "whatsapp"
      ).toLowerCase();

      this.showBotModal = false;

      // `retrieveChats` solo devuelve conversaciones CON reserva, así que este es el
      // camino normal. El fallback a la mensajería general cubre datos antiguos.
      if (reservaId) {
        this.$root.$emit("open-reservation-drawer", {
          userId: this.user?.id,
          reservaId,
          // Nombres de pestaña de ReservationConversations: whatsapp | web | otas
          tab: channel === "ota" ? "otas" : channel === "web" ? "web" : "whatsapp",
          chatId,
        });
        return;
      }

      if (chatId) {
        this.$router
          .push({ name: "PageMensajes", query: { chat: String(chatId) } })
          .catch(() => {});
      }
    },

    viewDetails(notification) {
      this.openConversation(notification);
    },

    replyToMessage(notification) {
      this.$emit("replyToNotification", notification);
      this.showBotModal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=DM+Sans:wght@500;600;700;800&family=Inter:wght@400;500;600;700;800&display=swap");

.notifications-shell,
.notifications-dropdown,
.notifications-head,
.notification-card,
.notifications-empty,
.bot-notification-btn {
  font-family: "DM Sans", sans-serif;
}

.notifications-head h4,
.notification-card h5,
.notif-chip {
  font-family: "DM Sans", sans-serif;
}

/*
 * El hueco entre iconos, de una sola vez y con la MISMA medida que los hermanos
 * de la barra (`.nav-guides-btn` y `.nav-novedades-btn` llevan 12px).
 *
 * Antes salia de tres sitios a la vez y se sumaban: `gap: 10px` en linea en esta
 * caja, `margin-inline: 10px` en linea en la campana y otro `margin-left: 10px`
 * en linea en el avatar. Medido en la barra: 12 - 22 - 20 - 20. Los dos del
 * medio son la campana y el robot, que es justo lo que se veia separado.
 *
 * El `gap` va a cero A PROPOSITO: el ultimo hijo de esta caja es
 * `.modal-bot-notifications`, que mide 0x0 mientras esta cerrado pero SIGUE
 * contando como hijo flex, asi que el `gap` le dejaba 10px muertos por detras al
 * robot. Con el hueco puesto como margen de la campana no hay hueco fantasma.
 */
.notifications-shell {
  display: flex;
  align-items: center;
  gap: 0;
}

.classic-notifications {
  margin-right: 12px;
}

/*
 * La misma caja que los botones hermanos de la barra (`.nav-guides-btn` y
 * `.nav-novedades-btn`, en Maqueta/Nav.vue): 44px, el mismo gris y un borde de
 * verdad. Estos dos iban por libre —42px, otro gris y una sombra interior
 * haciendo de borde— y en una fila de cuatro círculos iguales eso canta: la
 * campana y el robot salían más pequeños y con el icono de otro color.
 */
.notif-trigger,
.contenedorNotificaciones {
  height: 44px;
  width: 44px;
  background: #f4f4f8;
  border: 1px solid #e9ebf1;
  border-radius: 999px;
  justify-content: center;
  align-items: center;
  position: relative;
}

.notification-btn,
.bot-notification-btn {
  border: none;
  background: transparent;
  width: 100%;
  height: 100%;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #673de6;
  transition: all 0.18s ease;
}

/* Ocultar el caret Bootstrap en los botones de notificación */
.notification-btn.dropdown-toggle::after,
.bot-notification-btn.dropdown-toggle::after {
  display: none !important;
}

.notification-btn:hover,
.bot-notification-btn:hover {
  background: #e2e8f0;
  color: #0f172a;
}

.notification-dot {
  color: #ef4444 !important;
  position: absolute;
  font-size: 7px;
  right: 10px;
  top: 10px;
  z-index: 2;
}


.notifications-dropdown {
  min-width: 29rem;
  float: left;
  left: -395px;
  top: 50px;
  padding: 0 !important;
  border: none !important;
  border-radius: 20px !important;
  overflow: hidden;
  box-shadow: 0px 0px 32px 4px #00000017 !important;
  background: #fff;
}

.popover-arrow-wrap {
  position: absolute;
  right: 79px;
  top: -8px;
}

.popover-arrow {
  z-index: 1;
  width: 21px;
  height: 21px;
  margin: -8px;
}

.notifications-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px 14px;
  border-bottom: 1px solid #eef2f7;
  background: linear-gradient(180deg, #ffffff 0%, #fcfcfd 100%);
}

.head-left h4 {
  margin: 0;
  font-size: 1.55rem;
  font-weight: 700;
  color: #2f2f2f;
  letter-spacing: -0.03em;
}

.head-left small {
  display: inline-block;
  margin-top: 2px;
  color: #94a3b8;
  font-size: 0.82rem;
  font-weight: 600;
}

.notifications-scroll {
  max-height: 420px;
  overflow-y: auto;
  padding: 10px 10px 12px;
  background: #ffffff;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 #f8fafc;
}

.notifications-scroll::-webkit-scrollbar {
  width: 6px;
}

.notifications-scroll::-webkit-scrollbar-track {
  background: #f8fafc;
}

.notifications-scroll::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 999px;
}

/* ── Tarjetas del dropdown (hora + categoría | título + estado·texto) ── */
.cn-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.cn-card {
  position: relative;
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 10px rgba(16, 24, 40, 0.05);
  padding: 11px 13px;
  cursor: pointer;
  transition: box-shadow 0.16s ease, transform 0.14s ease;
  font-family: "DM Sans", sans-serif;
}
.cn-card:hover {
  box-shadow: 0 8px 22px rgba(16, 24, 40, 0.1);
  transform: translateY(-1px);
}
/* Línea conectora en el hueco entre cards (alineada con el divisor) */
.cn-card::after {
  content: "";
  position: absolute;
  left: 34px;
  top: 104%;
  height: 8px;
  width: 1px;
  background: #d9dee6;
}
.cn-card:last-child::after {
  display: none;
}
.cn-left {
  flex-shrink: 0;
  width: 48px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.cn-hour {
  font-size: 0.95rem;
  font-weight: 700;
  color: #1f2733;
  line-height: 1.1;
  letter-spacing: -0.01em;
  font-variant-numeric: tabular-nums;
}
.cn-cat {
  margin-top: 3px;
  font-size: 0.62rem;
  font-weight: 500;
  color: #9aa3b2;
}
.cn-divider {
  width: 1px;
  align-self: stretch;
  background: #dfe3ea;
  margin: 1px 11px;
}
.cn-main {
  flex: 1;
  min-width: 0;
}
.cn-title {
  margin: 0 0 2px;
  font-size: 0.92rem;
  font-weight: 700;
  line-height: 1.25;
  color: #1f2733;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cn-line {
  margin: 0;
  font-size: 0.84rem;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  /* Reserva 2 líneas siempre → todas las tarjetas con el mismo alto. */
  min-height: 2.35rem;
}
.cn-status {
  font-weight: 700;
}
.cn-sep {
  color: #c5cad3;
  margin: 0 4px;
}
.cn-text {
  color: #8a94a3;
}
.cn-chev {
  flex-shrink: 0;
  margin-left: 10px;
  color: #c8cfd9;
  font-size: 0.8rem;
  transition: transform 0.15s ease, color 0.15s ease;
}
.cn-card:hover .cn-chev {
  color: #94a3b8;
  transform: translateX(2px);
}

/* Color del estado por tipo */
/* Cada notificación colorea SU estado (derecha) y SU categoría (izquierda) con el
   mismo tono, para que se lea coherente (categoría un punto más oscura). La
   categoría "sistema" (slate) se queda en gris neutro. */
.tone-green  .cn-status { color: #1f9d4d; }  .tone-green  .cn-cat { color: #15803d; }
.tone-blue   .cn-status { color: #2f6fed; }  .tone-blue   .cn-cat { color: #1d4ed8; }
.tone-red    .cn-status { color: #db3b3b; }  .tone-red    .cn-cat { color: #b91c1c; }
.tone-teal   .cn-status { color: #0d9488; }  .tone-teal   .cn-cat { color: #0f766e; }
.tone-slate  .cn-status { color: #64748b; }
.tone-orange .cn-status { color: #d97706; }  .tone-orange .cn-cat { color: #b45309; }
.tone-purple .cn-status { color: #7c3aed; }  .tone-purple .cn-cat { color: #6d28d9; }
.tone-emerald .cn-status { color: #059669; } .tone-emerald .cn-cat { color: #047857; }
.tone-rose   .cn-status { color: #e11d48; }  .tone-rose   .cn-cat { color: #be123c; }
.tone-indigo .cn-status { color: #5b34c4; }  .tone-indigo .cn-cat { color: #4c1d95; }
/* Pago en proceso: mismo fondo/estilo que las demás; texto en ámbar (estado +
   categoría) para diferenciarla de una reserva confirmada (verde). */
.tone-amber  .cn-status { color: #d97706; }  .tone-amber  .cn-cat { color: #b45309; }

.unread-indicator-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #2993ff;
  box-shadow: 0 0 0 4px rgba(41, 147, 255, 0.08);
}

.notifications-empty {
  text-align: center;
  padding: 40px 24px;
  background: #fff;
}

.notifications-empty .empty-icon {
  margin-bottom: 14px;
}

.notifications-empty h5 {
  margin: 0 0 6px 0;
  color: #1f2937;
  font-size: 1rem;
  font-weight: 700;
}

.notifications-empty p {
  margin: 0;
  color: #94a3b8;
  font-size: 0.9rem;
  line-height: 1.5;
}

/* ── Footer: ver todas (link sobrio, sin botón grande) ── */
.notifications-foot {
  display: flex;
  justify-content: flex-end;
  padding: 11px 18px 14px;
  border-top: 1px solid #f1f5f9;
  background: #fff;
}
.ntf-seeall {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border: none;
  background: none;
  padding: 0;
  font-family: "DM Sans", sans-serif;
  font-size: 0.86rem;
  font-weight: 700;
  color: #673de6;
  cursor: pointer;
  transition: color 0.15s ease;
}
.ntf-seeall i {
  font-size: 0.76rem;
  transition: transform 0.15s ease;
}
.ntf-seeall:hover {
  color: #5b34c4;
}
.ntf-seeall:hover i {
  transform: translateX(3px);
}

.icon-green {
  background: #e8f8ec;
  color: #2f7d32;
}
.icon-blue {
  background: #e8f2ff;
  color: #3271d6;
}
.icon-red {
  background: #ffeaea;
  color: #d63b3b;
}
.icon-slate {
  background: #eef2f6;
  color: #64748b;
}
.icon-orange {
  background: #fff4e8;
  color: #d97706;
}
.icon-purple {
  background: #f1ebff;
  color: #7c3aed;
}
.icon-emerald {
  background: #eafcf4;
  color: #059669;
}
.icon-rose {
  background: #fff0f3;
  color: #e11d48;
}

.chip-green {
  background: #e7f7eb;
  color: #2f9e44;
}
.chip-blue {
  background: #eaf3ff;
  color: #2f80ed;
}
.chip-red {
  background: #fdecec;
  color: #dc2626;
}
.chip-slate {
  background: #eef2f7;
  color: #64748b;
}
.chip-orange {
  background: #fff3e6;
  color: #d97706;
}
.chip-purple {
  background: #efe7ff;
  color: #7c3aed;
}
.chip-emerald {
  background: #e7fbf1;
  color: #059669;
}
.chip-rose {
  background: #ffe8ef;
  color: #e11d48;
}

.inactive {
  display: none !important;
}

:deep(.bot-modal-dialog) {
  .p-dialog {
    position: fixed !important;
    top: 0 !important;
    right: 0 !important;
    height: 100vh !important;
    width: 450px !important;
    margin: 0 !important;
    border-radius: 0 !important;
    box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15) !important;
  }

  .p-dialog-content {
    padding: 0 !important;
    height: calc(100vh - 120px) !important;
    overflow: hidden !important;
  }

  .p-dialog-header {
    background: white !important;
    border-bottom: 1px solid #f0f0f0 !important;
    padding: 1.5rem !important;
    border-radius: 0 !important;
  }

  .p-dialog-footer {
    background: white !important;
    border-top: 1px solid #f0f0f0 !important;
    padding: 1.5rem !important;
    border-radius: 0 !important;
  }
}

.bot-notification-btn {
  position: relative;
  overflow: hidden;
}


@media (max-width: 768px) {
  .notifications-dropdown {
    min-width: 92vw;
    left: auto;
    right: -10px;
  }

  :deep(.bot-modal-dialog) .p-dialog {
    width: 100vw !important;
    left: 0 !important;
  }
}
</style>
